<template>
  <div>
    <top-header-info></top-header-info>
    <div>
      <div class="w">
        <div class="top_info">
          <el-row>
            <el-col :span="12" class="title"
              ><i class="el-icon-time"></i>等待支付，剩余<pay-countdown
                v-if="endTime"
                class="count"
                :endTime="endTime"
              ></pay-countdown>
            </el-col>
            <el-col :span="12" class="price">
              <div>
                订单金额：
                <span class="red_word"> {{ orderTotal | jifen }}</span
                >，本次已抵扣余额<span class="red_word">
                  {{ creditTotal | jifen }}</span
                >
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16" class="hint"
              >您的订单已提交，请在倒计时内完成支付，全余额支付也需点击<span
                class="red_word"
                >"立即支付"</span
              >按钮确认支付，否则订单会<span class="red_word"
                >自动取消</span
              ></el-col
            >
            <el-col :span="8" class="show_detail">
              <div @click="showDetail = !showDetail">
                订单详情
                <i
                  :class="
                    showDetail ? 'el-icon-caret-bottom' : 'el-icon-caret-right'
                  "
                ></i>
              </div>
            </el-col>
          </el-row>
          <el-row class="order_detail" v-show="showDetail">
            <el-col :span="6">
              收货人：
              <span
                >{{ orderInfo.shipping_name }}
                {{ orderInfo.shipping_phone }}</span
              >
            </el-col>
            <el-col :span="12">
              收货地址：
              <span
                >{{ orderInfo.zone && orderInfo.zone }}
                {{ orderInfo.city && orderInfo.city }}
                {{ orderInfo.area && orderInfo.area }}
                {{ orderInfo.town && orderInfo.town }}
                {{
                  orderInfo.shipping_address && orderInfo.shipping_address
                }}</span
              >
            </el-col>
            <el-col :span="6">
              订单号：
              <span>{{ orderInfo.id }}</span>
            </el-col>
            <el-col class="products_name">
              <el-row>
                <el-col :span="1.5">商品名称：</el-col>
                <el-col :span="20">
                  <span v-for="item in orderInfo.products" :key="item.id">{{
                    item.name
                  }}</span>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
        <div class="bottom_info">
          <div class="bot_title">
            选择的支付方式：{{
              curPaymethodCode === "alipay_direct"
                ? "支付宝即时到账"
                : curPaymethodCode === "qrcode_wxpay"
                ? "微信扫码支付"
                : "账户余额"
            }}
          </div>
          <el-radio-group v-model="curPaymethodCode" v-if="!showBarcode">
            <el-row
              class="pay_item"
              v-for="(item, index) in payMethods"
              :key="index"
            >
              <el-col :span="20">
                <el-radio :label="item.code"></el-radio>
                <img
                  width="40"
                  v-if="item.code === 'credit'"
                  height="40"
                  src="../../assets/images/yue.png"
                  align="center"
                />
                &nbsp;
                <img
                  width="40"
                  v-if="item.code === 'alipay_direct'"
                  height="40"
                  src="../../assets/images/ali.png"
                  align="center"
                />
                &nbsp;
                <img
                  width="40"
                  v-if="item.code === 'qrcode_wxpay'"
                  height="40"
                  src="../../assets/images/weixin.png"
                  align="center"
                />
                &nbsp;{{ item.title }}
                <!-- <span class="remain" v-if="item.code === 'credit'">
                  可用余额：
                  <span class="red_word">{{ balance | jifen }}</span>
                </span> -->
              </el-col>
              <el-col :span="4" v-if="item.code === curPaymethodCode">
                还需付款：
                <span class="red_word">{{ orderInfo.total | jifen }}</span>
              </el-col>
            </el-row>
          </el-radio-group>

          <div v-else class="weixin_pay clearfix">
            <div class="left_code">
              <img :src="code" alt="code" />
              <p>微信扫一扫支付</p>
            </div>
            <div class="right_img">
              <img src="../../assets/images/weixin_scan.png" alt />
            </div>
          </div>
        </div>
        <div class="but_wrap" v-if="!showBarcode">
          <el-button @click="doPayNow">立即支付</el-button>
        </div>
      </div>
      <bottom-content></bottom-content>
    </div>
    <div class="mask_wrap" v-show="showMask">
      <div>
        <el-row class="mask_title">
          <el-col :span="23">
            <p>
              <i :class="statusClass"></i>
              {{ statusText }}！
            </p>
          </el-col>
          <el-col :span="1">
            <i class="el-icon-close" @click="showMask = false"></i>
          </el-col>
        </el-row>
        <el-row class="mask_info">
          <el-col :span="24">
            <ul>
              <li>
                订单编号：
                {{ orderInfo.id }}
              </li>
              <li>
                订单合计：<span>{{ sub_total | jifen }}</span>
                账户余额支付：<span>{{ credit_total | jifen }}</span>
                实际自费支付：<span>{{ total | jifen }}</span>
              </li>
              <li>
                配送至：
                {{ orderInfo.zone && orderInfo.zone }}
                {{ orderInfo.city && orderInfo.city }}
                {{ orderInfo.area && orderInfo.area }}
                {{ orderInfo.town && orderInfo.town }}
                {{ orderInfo.shipping_address && orderInfo.shipping_address }}
              </li>
              <li>
                配送方式：
                {{ orderInfo.shipping_method }}
              </li>
            </ul>
          </el-col>
        </el-row>
        <el-row
          class="lottery"
          v-show="lottery_url && orderInfo.status_id !== 1"
        >
          <div class="title">恭喜您获得抽奖资格</div>
          <div class="message">海量精选奖品，等待抽取~</div>
          <div class="img">
            <img src="../../assets/images/lottery.png" alt="" />
            <canvas
              ref="myCanvas"
              style=" 
              position: absolute;
              top: 120px;
              left: 0;
              right:0;margin:auto;"
            ></canvas>
          </div>
          <div class="info">微信扫描参与抽奖</div>
        </el-row>
        <div
          class="lottery user-list"
          ref="user_list"
          v-show="user_list.length > 0"
        >
          <div
            class="user-item"
            v-for="(item, index) in user_list"
            :key="index"
          >
            <img :src="item.headImgUrl" />
            <div class="phone">{{ item.nickName }}</div>
            <div class="message">{{ item.prizeName }}</div>
          </div>
        </div>
        <el-row class="mask_button">
          <el-col :span="12">
            <router-link
              v-if="orderInfo.status_id !== 1"
              :to="{ name: 'index' }"
              replace
              >返回首页</router-link
            >
            <router-link v-else :to="{}" @click.native="showMask = false"
              >返回重新支付</router-link
            >
          </el-col>
          <el-col :span="12">
            <router-link :to="{ name: 'order-detail' }" replace
              >查看订单</router-link
            >
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import QrCode from "qrcode";
import TopHeaderInfo from "@/components/top-header-info";
import BottomContent from "@/components/bottom-content";
import payCountdown from "@/components/pay-countdown/index.vue";
export default {
  components: {
    TopHeaderInfo,
    BottomContent,
    payCountdown
  },
  data() {
    return {
      showDetail: false,
      payway: "",
      orderInfo: { totals: [] },
      showMask: false,
      showBarcode: false,
      timer: "",
      balance: 0,
      curPaymethodCode: "",
      payMethods: [],
      endTime: "",
      user_list: [],
      sub_total: 0,
      credit_total: 0,
      total: 0,
      lottery_url: "",
      timer1: null,
      scroll_top: 0
    };
  },
  mounted() {
    if (this.$route.query.type === "alipay") {
      this.showMask = true;
      this.getData(true);
    } else {
      this.getData();
    }
    this.getBalance();
  },
  computed: {
    statusClass() {
      return this.orderInfo.status_id !== 1
        ? "el-icon-circle-check"
        : "el-icon-circle-close";
    },
    statusText() {
      return this.orderInfo.status_id !== 1 ? "支付成功" : "支付失败";
    },
    orderTotal() {
      let sub_total = 0;
      let shipping = 0;
      this.orderInfo.totals.map(item => {
        if (item.code == "sub_total") {
          sub_total = parseFloat(item.value);
        } else if (item.code == "shipping") {
          shipping = parseFloat(item.value);
        }
      });
      return (sub_total + shipping).toFixed(2);
    },
    creditTotal() {
      let creditTotal = 0;
      this.orderInfo.totals.map(item => {
        if (item.code == "credit") {
          creditTotal = Math.abs(item.value);
        }
      });
      return creditTotal;
    }
  },
  methods: {
    getData(key = false) {
      let id = this.$route.params.order_id;
      const now_time = new Date();
      this.$reqGet("api/ecomm/order/" + id).then(res => {
        this.orderInfo = res.data.data;
        if (this.orderInfo.iso_end_time) {
          const endTime = this.orderInfo.iso_end_time;
          const current_time = this.orderInfo.current_time;
          const deff_time = (new Date() - now_time) / 2;
          const launch_time =
            deff_time +
            new Date(endTime).getTime() -
            new Date(current_time).getTime();
          this.endTime = new Date(now_time.getTime() + launch_time);
        }
        this.orderInfo.totals.map(item => {
          if (item.code === "sub_total") {
            this.sub_total = parseFloat(item.value).toFixed(2);
          }
          if (item.code === "credit") {
            this.credit_total = parseFloat(item.value).toFixed(2);
          }
          if (item.code === "total") {
            this.total = parseFloat(item.value).toFixed(2);
          }
        });
        if (key && this.orderInfo.status_id !== 1) {
          this.getLottery();
        }
      });
      this.$reqGet("api/store/order/payments_method/" + id).then(res => {
        this.payMethods = res.data.data;
        if (this.payMethods.length > 0) {
          this.curPaymethodCode = this.payMethods[0].code;
        }
      });
    },
    getLottery() {
      this.$reqGet("/api/customization/eqxiu/login", {
        order_id: this.$route.params.order_id
      }).then(res => {
        if (res.data.success) {
          this.lottery_url = res.data.data.url;
          this.$nextTick(() => {
            QrCode.toCanvas(this.$refs.myCanvas, res.data.data.url, {
              width: 160,
              height: 160
            });
          });
          if (this.lottery_url) {
            this.getLatestLottery();
          }
        }
      });
    },
    getLatestLottery() {
      this.$reqGet("/api/customization/eqxiu/latestLottery", {
        order_id: this.$route.query.order_id
      }).then(res => {
        if (res.data.success) {
          this.user_list = res.data.data.splice(0, 50);
          clearInterval(this.timer1);
          this.$nextTick(() => {
            this.timer1 = setInterval(() => {
              if (this.$refs.user_list) {
                this.scroll_top++;
                this.$refs.user_list.scrollTop = this.scroll_top;
                if (this.scroll_top > this.$refs.user_list.scrollTop) {
                  this.user_list.push(...this.user_list);
                }
              }
            }, 50);
          });
        }
      });
    },
    doPayNow() {
      if (this.curPaymethodCode == "alipay_direct") {
        this.aliPay();
      } else if (this.curPaymethodCode == "qrcode_wxpay") {
        this.wxpay();
      } else if (this.curPaymethodCode == "credit") {
        this.scorePay();
      } else {
        this.$message({ message: "暂不支持此支付方式", type: "warning" });
      }
    },
    getBalance() {
      this.$reqGet("api/distribch/account/balance").then(res => {
        this.balance = res.data.data.balance;
      });
    },
    // 支付宝
    aliPay() {
      this.$reqPost("api/store/payment/aliWeb/" + this.orderInfo.id).then(
        res => {
          let html = res.data.data.pay;
          document.body.innerHTML = html;
          document.forms["alipay_submit"].submit();
        }
      );
    },
    // 微信支付
    wxpay() {
      this.$reqPost("api/store/payment/wxScan/" + this.orderInfo.id).then(
        res => {
          this.showBarcode = true;
          this.code = res.data.data.pay;
        }
      );
      this.check();
    },
    // 积分支付
    scorePay() {
      this.$reqPost("api/store/payment/scorePay/" + this.orderInfo.id).then(
        res => {
          if (res.data.status == 200) {
            this.getData(true);
            this.showMask = true;
          }
        }
      );
    },
    check() {
      this.timer = setInterval(() => {
        this.$reqGet("api/store/order/paid_status/" + this.orderInfo.id).then(
          res => {
            if (res.data.data.success) {
              clearInterval(this.timer);
              this.getData(true);
              this.showMask = true;
            }
          }
        );
      }, 3000);
    }
  },
  destroyed() {
    clearInterval(this.timer);
  }
};
</script>

<style lang="less" scoped>
.el-icon-close {
  cursor: pointer;
}
.top_info {
  padding: 20px 30px;
  background: #fff;
  margin: 20px 0;

  .title {
    font-size: 24px;
    color: #ff0000;
    font-weight: 500;
    line-height: 36px;
    .el-icon-time {
      margin-right: 16px;
    }
  }
  .price {
    text-align: right;
  }
  .hint {
    line-height: 36px;
    text-indent: 40px;
    .red_word {
      font-weight: 500;
    }
  }
  .show_detail {
    text-align: right;
    color: #1b6cab;
    cursor: pointer;
    i {
      color: #1b6cab;
    }
  }
  .order_detail {
    border-top: 1px solid #ddd;
    color: #999;
    line-height: 36px;
    span {
      color: #333;
    }
    .products_name span {
      display: block;
    }
  }
}
.el-radio /deep/ .el-radio__label {
  font-size: 0;
}
.el-radio /deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #e2333f;
  background-color: #e2333f;
}
.bottom_info {
  background-color: #fff;
  padding: 20px 30px;
  .el-radio-group {
    display: block;
    font-size: 14px;
    .recharge {
      border: 1px solid rgba(226, 51, 63, 1);
      border-radius: 13px;
      height: 26px;
      line-height: 26px;
      padding-top: 0;
      margin-left: 8px;
      color: rgba(226, 51, 63, 1);
    }
  }
  .bot_title {
    font-size: 16px;
    color: rgba(34, 34, 34, 1);
    line-height: 36px;
    border-bottom: 2px solid #ddd;
  }
  .pay_item {
    padding: 20px;
    border-bottom: 1px solid #ddd;
    line-height: 40px;
    box-sizing: border-box;
    img {
      position: absolute;
      left: 50px;
      width: 40px;
      height: 40px;
    }
    .remain {
      margin-left: 15px;
    }
  }
}
.statusIcon {
  width: 20px;
}
.but_wrap {
  padding: 30px;
  text-align: right;
  background-color: #fff;
  .el-button {
    width: 198px;
    height: 46px;
    background: rgba(226, 51, 63, 1);
    border-radius: 5px;
    font-size: 16px;
    color: #fff;
    border: none;
  }
}
.mask_wrap {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  background: rgba(1, 1, 1, 0.6);
  > div {
    position: absolute;
    width: 800px;
    max-height: 800px;
    overflow-y: auto;
    padding: 0 15px;
    background: rgba(255, 255, 255, 1);
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .mask_title {
    text-align: center;
    font-size: 26px;
    margin: 10px 20px;
    color: #333;
    border-bottom: 1px solid #bbb;
    i {
      color: #bbb;
    }
    .el-icon-circle-check {
      color: #5eb95a;
    }
    .el-icon-circle-close {
      color: #e2333f;
    }
  }
  .mask_info {
    .goods_title {
      font-size: 20px;
      color: rgba(0, 0, 0, 1);
      line-height: 32px;
    }
    ul {
      li {
        color: #333333;
        line-height: 30px;
        font-size: 14px;
        > span {
          color: #ff482c;
        }
      }
    }
  }
  .lottery {
    background-color: #fff9ec;
    border: 1px solid #f0d985;
    text-align: center;
    padding: 10px;
    color: #333;
    > .title {
      font-size: 20px;
      margin-bottom: 10px;
    }
    > .message {
      font-size: 18px;
      color: #e2343f;
    }
    > .img {
      width: 426px;
      height: 300px;
      margin: 0 auto;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .info {
      font-size: 12px;
      padding-top: 10px;
    }
  }
  .user-list {
    margin-top: 10px;
    height: 100px;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    > .user-item {
      display: flex;
      height: 25px;
      font-size: 12px;
      align-items: center;
      padding: 5px 0;
      &:first-child {
        margin-top: 0;
      }
      > img {
        border-radius: 50%;
        width: 24px;
        height: 24px;
      }
      > .phone {
        margin-left: 10px;
        color: #333;
      }
      > .message {
        color: #ff482c;
        margin-left: 20px;
      }
    }
  }
  .mask_button {
    padding: 30px 150px;
    text-align: center;
    a {
      display: inline-block;
      width: 146px;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      color: #fff;
      background: rgba(226, 51, 63, 1);
      border-radius: 5px;
    }
    > div:last-child a {
      background: rgba(250, 250, 250, 1);
      border: 1px solid rgba(219, 219, 219, 1);
      color: #333;
    }
  }
}
.weixin_pay {
  > div {
    display: inline-block;
    width: 47%;
  }
  .left_code {
    float: left;
    text-align: center;
    padding-top: 120px;
    padding-left: 60px;
    img {
      width: 160px;
      height: 160px;
      border: 1px solid rgba(205, 205, 205, 1);
      padding: 3px;
    }
  }
  .right_img {
    img {
      width: 280px;
      margin-top: 60px;
    }
  }
}
.red_word {
  color: #ff0000;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/submit-order.vue